import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Translate } from 'react-localize-redux';
import { DISABLED_REASONS, TRANSLATE_PREFIX } from '../consts';
import IntegrationIcon from './IntegrationIcon';
import css from './IntegrationCell.css';

const getDisabledMessageKey = row => {
    if (row.disabledReason === DISABLED_REASONS.PROFILE_INCOMPLETE) {
        return `${TRANSLATE_PREFIX}.DISABLED.PROFILE_INCOMPLETE_MESSAGE`;
    }

    return null;
};

const IntegrationCell = ({ row }) => (
    <td>
        <div className={classNames(css.integrationCell, { [css.centered]: row.isSubRow })}>
            <IntegrationIcon type={row.card.type} />
            <div className={css.integrationText}>
                <span className={css.cardTitle}>
                    <Translate id={row.card.titleKey} />
                </span>
                {!row.isSubRow && (
                    <span className={css.cardDescription}>
                        <Translate id={row.card.descriptionKey} />
                    </span>
                )}
                {row.disabled && (
                    <span className={css.disabledMessage}>
                        <Translate id={getDisabledMessageKey(row)} />
                    </span>
                )}
            </div>
        </div>
    </td>
);

IntegrationCell.propTypes = {
    row: PropTypes.shape({
        card: PropTypes.shape({
            type: PropTypes.string.isRequired,
            titleKey: PropTypes.string.isRequired,
            descriptionKey: PropTypes.string.isRequired,
        }).isRequired,
        disabled: PropTypes.bool.isRequired,
        disabledReason: PropTypes.string,
        isSubRow: PropTypes.bool,
    }).isRequired,
};

export default IntegrationCell;
